exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/learner-progress.js-WebpackMultiOutput";